import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';

import useTranslation from 'hooks/use-translation';

import ROUTES from 'src/routes';
import { Link } from 'components/core';

const { ACCOUNT, PREFERENCES, ORDERS } = ROUTES;

export const LoggedOutOptionsListItem = ({ onOptionClick }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <OptionItem onClick={() => onOptionClick(`createAnAccount`)}>
        {t('accountOptions.createAccount', 'Create an Account')}
      </OptionItem>
      <OptionItem onClick={() => onOptionClick(`login`)}>{t('accountOptions.login', 'Login')}</OptionItem>
    </Fragment>
  );
};

export const LoggedInOptionsListItem = ({ onLogout }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Link href={ACCOUNT}>
        <Anchor href={ACCOUNT}>{t('accountOptions.myAccount', 'My Account')}</Anchor>
      </Link>
      <Link href={PREFERENCES}>
        <Anchor href={PREFERENCES}>{t('accountOptions.preferences', 'Preferences')}</Anchor>
      </Link>
      <Link href={ORDERS}>
        <Anchor href={ORDERS}>{t('accountOptions.orders', 'Orders')}</Anchor>
      </Link>

      <OptionItem onClick={onLogout}>{t('accountOptions.logout', 'Logout')}</OptionItem>
    </Fragment>
  );
};

const listItemStyles = css`
  width: 187px;
  font-size: 14px;
  line-height: 175%;
  color: ${({ theme }) => theme.colors.grey[30]};
  cursor: pointer;
  text-align: left;
  padding-left: 30px;
  height: 37px;
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryGrey};
  }
`;

const OptionItem = styled.div`
  ${listItemStyles}
`;

const Anchor = styled.a`
  ${listItemStyles}
`;
